// extracted by mini-css-extract-plugin
module.exports = {"container":"Inventory_container__vM5ik"};